import type { Agent } from '../types/api-types';
import type { DataItem } from '../../../../utils/interface-types';
import type { WebSearchMode } from './chat-model-persist';

type AgentToolFlagKey = 'code_interpreter_enabled' | 'web_search_enabled' | 'mcp_enabled';

/** Agent feature flags (0/1 from API) gate user toggles for chat sends. */
export function effectiveAgentToolEnabled(
  activeAgent: Agent | null | undefined,
  agentFlagKey: AgentToolFlagKey,
  userToggle: boolean,
): boolean {
  if (activeAgent != null) {
    const flag = activeAgent[agentFlagKey];
    if (flag === undefined || flag === null) {
      return userToggle;
    }
    if (!Number(flag)) {
      return false;
    }
  }
  return userToggle;
}

export function effectiveAgentWebSearchMode(
  activeAgent: Agent | null | undefined,
  userMode: WebSearchMode,
): WebSearchMode {
  if (activeAgent != null) {
    const flag = activeAgent.web_search_enabled;
    if (flag !== undefined && flag !== null && !Number(flag)) {
      return 'off';
    }
  }
  return userMode;
}

export function mergeWebSearchSources(
  existing: DataItem['sources'] | undefined,
  incoming: DataItem['sources'] | undefined,
): NonNullable<DataItem['sources']> {
  const prev = existing || [];
  const next = incoming || [];
  const seen = new Set(
    prev
      .map((source) => (source.link || source.hostname || source.title || '').toLowerCase())
      .filter(Boolean),
  );
  const merged = [...prev];
  next.forEach((source) => {
    const key = (source.link || source.hostname || source.title || '').toLowerCase();
    if (key && seen.has(key)) {
      return;
    }
    if (key) {
      seen.add(key);
    }
    merged.push(source);
  });
  return merged;
}
